export default function GradientText({ children, className = '' }) {
	return (
		<svg
			className={`inline-block overflow-visible ${className}`}
			style={{ height: '1.6em' }}
		>
			<defs>
				<linearGradient id="textFill" x1="0%" y1="0%" x2="0%" y2="100%">
					<stop offset="0%" stopColor="rgba(255,255,255,1)" />
					<stop offset="100%" stopColor="rgba(254,248,209,1)" />
				</linearGradient>

				<linearGradient id="textStroke" x1="0%" y1="0%" x2="100%" y2="100%">
					<stop offset="0%" stopColor="rgba(229,192,168,1)" />
					<stop offset="33%" stopColor="rgba(199,114,75,1)" />
					<stop offset="66%" stopColor="rgba(250,225,202,1)" />
					<stop offset="100%" stopColor="rgba(200,110,72,1)" />
				</linearGradient>

				<filter id="textShadow" x="-30%" y="-30%" width="160%" height="160%">
					<feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="rgba(149,71,36,1)" />
				</filter>
			</defs>

			<text
				x="50%"
				y="50%"
				textAnchor="middle"
				dominantBaseline="middle"
				style={{ fontSize: '1em', fontWeight: 'bold' }}
				fill="url(#textFill)"
				stroke="url(#textStroke)"
				strokeWidth="0.015em"
				paintOrder="stroke fill"
				filter="url(#textShadow)"
			>
				{children}
			</text>
		</svg>
	)
}